define('core/services/TimeService',['angular'], function (angular) {
    'use strict';
    return angular.module('dnaApp').service('TimeService', function () {
        /**
         * @class TimeService
         * @desc Service that provides time functions.
         */
        return {
            /**
             * @method currentTime
             * @returns {Number} The current time in milliseconds.
             * @public
             */
            currentTime: function () {
                return new Date().getTime();
            },


            /**
             * @method withinTimePeriod
             * @desc Determine if we are within a specified time period.
             * @param startTime When we began the timer.
             * @param timeLength How much time should we wait.
             * @returns {boolean}
             * @public
             */
            withinTimePeriod: function (startTime, timeLength) {
                return (new Date().getTime() - startTime) <= timeLength;
            },

            /**
             * @method withinTimePeriod
             * @desc Determine if we are within a specified time period.
             * @param startTime When we began the timer.
             * @param timeLength How much time should we wait.
             * @returns {boolean}
             * @public
             */
            timeElapsed: function (startTime, timeLength) {
                return (new Date().getTime() - startTime) > timeLength;
            }
        };
    });
});
